import Home from "./images/home.svg";
import Location from "./images/location.svg";
import Work from "./images/work.svg";

export const MAP_HEIGHT = 348;
export const HI_MAP_HEIGHT = 155;
export const CURRENT_LOCATION_ACCURACY_FLAG = true;

export const MAP_OPTIONS = {
    gestureHandling: "greedy",
    clickableIcons: false,
    zoom: 19,
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: false,
    styles: [
        {
            featureType: "poi.business",
            stylers: [{ visibility: "on" }]
        }
    ]
};

export const TAB_LIST = [
    {
        title: "Home",
        icon: Home,
        description: "Use if you’re currently at Home",
        placeholder: "Search by area/street name/society",
        hiPlaceHolder: "House/Flat No/Street name*"
    },
    {
        title: "Work",
        icon: Work,
        description: "Use if you’re currently at work",
        placeholder: "Search by company/building name",
        hiPlaceHolder: "Building Name/Plot No*"
    },
    {
        title: "Other",
        icon: Location,
        description: "Use if you’re at the inspection location",
        placeholder: "Search by area/street name/society",
        hiPlaceHolder: "House/Flat No/Street name*"
    }
];
